module.exports = __webpack_public_path__ + "static/map_vertical_eur-8c00ca76b93c5cb2d7956bdf7c6b4c8b.png";